// frontend/src/components/FeaturedCourse.js
import React from 'react';
import CourseCard from './CourseCard';

const FeaturedCourses = ({ courses, onNavigate, onSelectCourse }) => {
  const featured = courses.slice(0, 4); // Mostrar los primeros 4 como destacados

  const handleCourseClick = (courseId) => {
    onSelectCourse(courseId);
    onNavigate('courseDetail');
  };

  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-8">Cursos destacados</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {featured.map(course => (
            <CourseCard
              key={course.id}
              course={course}
              onClick={() => handleCourseClick(course.id)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCourses;